
<template>
  <div class='about'>
    <div class='background absolute' @click.prevent='close'></div>
    <div class='content'>
      <h3>FieldPlay <a class='close bold' href='#' @click.prevent='close'>close</a></h3>
      <p>
	This is an exact copy of the beautiful applet created by Anvaka and described by them below. 
      </p>
      <details><summary>It is licensed under the MIT license</summary>
	<p>
	  The MIT License (MIT)
	</p>
	<p>
	  Copyright (c) 2017-2024 Andrei Kashcha
	</p>
	<p>
	  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	</p>
	<p>
	  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
	</p>
	<p>
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	</p>
	  </details>
</p>
<hr>
      <p>
        This website allows you to explore vector fields in real time.
      </p>
      <p>
        "Vector field" is just a fancy way of saying that each point on a screen has some vector
        associated with it. This vector could mean anything, but for our purposes we consider it to be 
        a velocity vector.
      </p>
      <p>
        Now that we have velocity vectors at every single point, let's drop thousands of small particles
        and see how they move. Resulting visualization could be used by scientist to study vector
        fields, or by artist to get inspiration!
      </p>
      <ul>
        <li>
          <a href='https://github.com/anvaka/fieldplay' class='highlighted'>Learn more </a> about this project on GitHub
        </li><li>
        Stay tuned for updates on <a href='https://twitter.com/anvaka' class='highlighted'>Twitter</a>
        </li><li>
        <a href='https://www.reddit.com/r/fieldplay/' class='highlighted'>/r/fieldplay</a> - join our small subreddit
        </li>

      </ul>
      <p>With passion,<br/> Anvaka</p>
      <a href='#' @click.prevent='close' class='large-close bold'>
        close
      </a>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.closeHandler = (e) => {
      if (e.keyCode === 27) {
        e.preventDefault();
        this.close();
      }
    }
    document.addEventListener('keyup', this.closeHandler);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.closeHandler);
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>
<style lang='stylus'>
@import "./shared.styl";

.about {
  position: absolute;
  overflow-y: auto;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  align-items: flex-start;

  .close {
    position: absolute;
    right: 15px;
    font-size: 12px;
  }
  .large-close {
    width: 100%;
    height: 32px;
    display: block;
    text-align: center;
  }
  .content {
    color: secondary-text;
    position: relative;
    background: window-background;
    width: 400px;
    padding: 14px;
    border: 1px solid primary-border;
    h3 {
      margin: 0;
      font-weight: normal;
    }
  }
}
.background {
  position: absolute;
  background-color: hsla(215, 74%, 18%, 0.8);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 800px) {
  .about {
    justify-content: initial;
  }
  .about .content {
    width: 100%;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue